// Only confirmed short windows are sent. No offline history, user input,
// URLs or mouse/key contents are stored or transmitted.
export function startEmployeeActivity({ host = window, doc = document, token, send, clock = () => host.performance.now() }) {
    if (typeof host.crypto?.randomUUID!=='function') return ()=>{}
    const source = host.crypto.randomUUID()
    let seq=0, visible=doc.visibilityState==='visible', last=clock(), interaction=last, pending=0, sent=last, stopped=false, inflight=false, wasPresent=visible
    const eligible = at => visible && at-interaction<120000
    const sample = at => {
        if (at-last>5000) pending=0
        else if (visible) pending+=Math.max(0,Math.min(at,interaction+120000)-last)
        last=at
    }
    const flush = (present=eligible(clock())) => {
        const at=clock();sample(at)
        if (stopped || inflight) return
        const active_ms=Math.min(30000,Math.floor(pending));pending=0;sent=at;wasPresent=present
        if (host.navigator.onLine===false) return
        inflight=true
        const body={source_id:source,seq:++seq,active_ms,present}
        Promise.resolve().then(()=>{if(!stopped||!present)return send(body,token)}).catch(()=>{})
            .finally(()=>{inflight=false})
    }
    const onInteraction = event => {
        if (event?.isTrusted===false) return
        const at=clock();sample(at);const before=eligible(at);interaction=at
        if (!before && visible) flush(true)
    }
    const onVisibility = () => {
        const at=clock();sample(at);visible=doc.visibilityState==='visible';last=at
        if (visible) {interaction=at;pending=0}
        flush(visible)
    }
    const onPageHide = () => {sample(clock());visible=false;flush(false)}
    const onPageShow = () => {visible=doc.visibilityState==='visible';interaction=last=clock();pending=0;flush(visible)}
    const onOnline = () => {pending=0;last=clock();flush()}
    const events=['pointerdown','keydown','scroll','touchstart']
    events.forEach(type=>doc.addEventListener(type,onInteraction,{passive:true,capture:true}))
    doc.addEventListener('visibilitychange',onVisibility)
    host.addEventListener('pagehide',onPageHide);host.addEventListener('pageshow',onPageShow);host.addEventListener('online',onOnline)
    const timer=host.setInterval(()=>{
        const at=clock();sample(at)
        const present=eligible(at)
        if (present!==wasPresent || at-sent>=30000 && present) flush(present)
        wasPresent=present
    },1000)
    flush(visible)
    return ()=>{
        if (stopped) return
        sample(clock());visible=false;flush(false);stopped=true
        host.clearInterval(timer)
        events.forEach(type=>doc.removeEventListener(type,onInteraction,true))
        doc.removeEventListener('visibilitychange',onVisibility)
        host.removeEventListener('pagehide',onPageHide);host.removeEventListener('pageshow',onPageShow);host.removeEventListener('online',onOnline)
    }
}
